import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Output, Input } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { UserTypeManagerService, UserType } from "../services/usertype/user-type-manager.service";
import {LayoutManagerService} from "../services/layout/layout-manager.service";
import {ReplayerService, OnReplayer} from "../player/replayer.service";
import {LogService} from "../services/log/log.service";


import {PermissionsManagerService} from "../services/permissions/permissions-manager.service";
declare var $;

declare var YT;
@Component({
    selector: "dskl-wb-link-youtube",
    templateUrl: 'link-youtube-wb.component.html',
    inputs: ["board"],
    outputs: ["change"]
})

export class LinkYoutubeWbComponent extends WhiteBoardComponent implements OnReplayer {

    lc: any;
    onStartPlaying() {
        if(this.player)
        this.player.playVideo()
    }

    onStopPlaying() {
        if(this.player)
        this.player.pauseVideo()
    }

    isReady() {
        return this.playerReady;
    }

    processState(){
        var state = this.unprocessedState;
        if (!state)return;
        console.log("Got state ", state);
       // var s = JSON.parse(state);
       var s = state;
        if (s && s.videoId){
            var self = this; 
        this.videoId = s.videoId;
        $("#youtube-filename").val(s.currentFilename);
        this.currentFilename = s.currentFilename
        switch(s.type){
            

            
            case "play": 
                
                this.play(s.videoId, function(){
                    self.player.seekTo(Number(s.position), true);  
                    self.onPlayerReady();   
                });
                
                break;
            case "loaded": 
                
            case "pause":
                       
                this.play(s.videoId, function(){
                    
                    self.player.seekTo(Number(s.position), true); 
                    self.player.playVideo();
                    self.player.stopVideo();
                     self.onPlayerReady();
                });
                
                break;
        }
        }
    }
    unprocessedState;
    onCurrentPageState(state, pageId){
        this.unprocessedState = state
        if (this.playerReady){
            this.processState()
        }
    }
    currentFilename;
    playerState;
     getCurrentState(){
         var p=0;
         if (this.player && typeof this.player.getCurrentTime =='function')
            p = this.player.getCurrentTime()
        let a = {type: this.playerState, videoId: this.videoId, currentFilename: this.currentFilename, position: p}
        console.log("Sending state ", a);
        return a;
}
        
    onReady() {

        this.translatePageName();
    }
    translatePageName() {
        this.translate.get('WB_PAGE_NAME.PAGE_LINKS').subscribe((res: string) => { this.pageName = res; });
    }
    getWbType() {
        return this.pageName;
    }
    pageName = "Дъска за линкове"
    constructor(protected log: LogService, private replayerService: ReplayerService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService, private userTypeManager: UserTypeManagerService, protected layoutService: LayoutManagerService, protected permissionsManager: PermissionsManagerService){
        super(log, wbService, sessionManager, layoutService, permissionsManager);
        this.replayerService.registerForReplaying(this)
    }
    onResize(){

    }
    changing = false;
    onState(state, pageId) {
      if (!this.replayerService)return;
        switch (state.type) {

            case "loaded": this.play(state.value.filename); break;
            case "pause": 
            this.player.pauseVideo(); break;
            case "play":
                this.playerState = "play"
                let p = state.value.position;//.split(",")[0];
                console.log("Will play from ", p)
                console.log("replayer service", this.replayerService)
                if(!this.player) {
                    this.play(state.value.filename, function(){
                        this.player.seekTo(Number(p), true);  
                        this.onPlayerReady();   
                    })
                }
                this.player.playVideo();
                this.player.seekTo(Number(p), true);  
        }
     

    }
    player;
    playerReady = false;
    onPlayerReady() {
        this.playerReady = true;
    }
    videoId;
    play(videoId, cb=null) {
         
        if (!this.player) {
            this.setupPlayer(videoId, cb);
        } else {
            this.player.loadVideoById(videoId, 0);
        }
    }
    load(url) {
        
        this.currentFilename = url;
        
        this.videoId = url.split('v=')[1];
        if (!this.videoId){
            this.videoId = url.split("youtu.be/")[1];
        }
        if (!this.videoId){
            console.log("noo")
        }
        var ampersandPosition = this.videoId.indexOf('&');
        if (ampersandPosition != -1) {
            this.videoId = this.videoId.substring(0, ampersandPosition);
        }
        console.log("Loading")
        this.play(this.videoId);
        this.changed("loaded", 0, this.videoId)
        
        
    }

    private changed(type, position, filename = null) {
       if (!this.canControl())return;

        this.emitChanged({ type: type, value: { position: position, filename: filename } });
    }

    onPlayerStateChange(event) {
 
        
        switch (event.data) {
            case YT.PlayerState.PLAYING:
                this.playerState = "play";
                this.changed("play", event.target.getCurrentTime(), this.videoId)
                
                break;

            case YT.PlayerState.PAUSED:
                this.playerState = "pause";
                this.changed("pause", event.target.getCurrentTime(), this.videoId)
                
                break;

        }

    }
    canControl() {
        
        return this.userTypeManager.getType() == UserType.TEACHER;
    }
    private setupPlayer(id, cb=null) {
        this.player = new YT.Player('player', {
            height: '390',
            width: '640',
            playerVars: { 'autoplay': 0, 'controls': this.canControl() ? 1 : 0, disablekb: this.canControl() ? 0 : 1 },
            videoId: id,
            events: {
                'onReady': cb?cb:this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange.bind(this)
            }
        });
    }
    onViewReady() {
        var tag = document.createElement('script');
        this.replayerService.registerForReplaying(this);
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        var self = this;
        window["onYouTubeIframeAPIReady"] = function () {
            console.log("Ready")
             self.onPlayerReady();
            self.playerState = "loaded";
            self.processState();
        }

    }

}



// WEBPACK FOOTER //
// /app/src/app/wb/links/link-youtube-wb.component.ts